import axios from 'axios'

let criticalRequestSemaphore = false

// Utility functions
export const lockCriticalRequest = (requestId) => {
  criticalRequestSemaphore = requestId
}

export const releaseCriticalRequest = (requestId) => {
  if (criticalRequestSemaphore === requestId) {
    criticalRequestSemaphore = false
  }
}

const _waitForRelease = (resolve, reject, iteration) => {
  if (iteration > 1000) {
    reject()
  }
  if (criticalRequestSemaphore !== false) {
    setTimeout(() => {
      _waitForRelease(resolve, reject, iteration + 1)
    }, 10)
  } else {
    resolve(true)
  }
}

axios.interceptors.request.use(async (config) => {
  return config
})
